import React from 'react'
import { motion } from "motion/react"
import { useRevealInitial } from "../lib/motion"

const AboutContent = () => {
  return (
    <section className="mx-auto max-w-2xl px-6 py-24" id="about">
      <motion.div
        initial={useRevealInitial({ opacity: 0, y: 16 })}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
      >
        <span className="font-mono text-sm uppercase tracking-widest text-signal-400">{"// 01 About"}</span>
        <h2 className="mt-3 mb-6 text-3xl font-semibold text-mist-100">About Me</h2>
        <p className="leading-relaxed text-mist-500">
          Hi, I'm Nate. I'm a software engineer at Rubrik and studied Computer Science at Duke. I like working on problems where the solution isn't just to make something faster, but to rethink how it gets done in the first place. I'm especially interested in what happens when new technology changes the shape of the problem, which is something I've been exploring a lot through AI.
        </p>
      </motion.div>
    </section>
  )
}

export default AboutContent
